<template>
  <div class="buy-did-container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-dids-local-did'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p style="white-space: nowrap">Back to DIDs</p>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title" style="white-space: nowrap;margin-left: 40px;">Search for number</span>
      <div class="table-container">
        <nav class="add-navigation">
          <div class="row w-100 p-3">
            <div class="col-md-3 col-12 search_margin no_title">
              <search-input
                  class="search-input"
                  type="text"
                  :value="pattern"
                  :maxlength="'10'"
                  @input="handlePatternSearch"
                  placeholder="Search for PATTERN"
              />

            </div>
            <div class="col-md-3 col-12 search_margin">
              <primary-select
                  type="text"
                  name="npa"
                  class="select"
                  :value="npa"
                  @input="handleNpaSearch"
                  :class="{'input': true, 'is-danger': errors.has('npa')}"
                  placeholder="npa"
                  :options="npas"
              />

            </div>
            <div class="col-md-3 col-12 search_margin">
              <primary-select
                  type="text"
                  name="count"
                  class="select"
                  :value="count"
                  @input="handleCountSearch"
                  :class="{'input': true, 'is-danger': errors.has('count')}"
                  placeholder="Lata"
                  :options="counts"
              />

            </div>
            <div class="buttons-wrapper col-md-1 col-2 ">
              <!--            v-if="!active"-->
              <div class="primary-button search_margin " >
                <primary-button @click.native="buyDid">Order Number</primary-button>
              </div>
            </div>


            <div class="col-md-3 col-12 search_margin">
              <primary-select
                  type="text"
                  name="lata"
                  class="select"
                  :value="lata"
                  @input="handleLataSearch"
                  :class="{'input': true, 'is-danger': errors.has('lata')}"
                  placeholder="Lata"
                  :options="latas"
              />

            </div>
            <div class="col-md-3 col-12 search_margin">

              <primary-select
                  type="text"
                  name="state"
                  class="select"
                  :value="state"
                  @input="handleStateSearch"
                  :class="{'input': true, 'is-danger': errors.has('state')}"
                  placeholder="state"
                  :options="states"
              />

            </div>
           <div class="buttons-wrapper col-md-1 col-3">
             <div class="primary-button search_button no_title mb-4 ">
               <primary-button @click.native="() => search()">Search</primary-button>
             </div>
           </div>

          </div>

        </nav>
        <div class="table-responsive">
        <loader :loading="loading" v-if="loading" />
        <table class="Invoice_table table" v-else>
          <thead>
            <tr class="Invoice_table_header">
              <th class="number">
                <img class="number-icon" src="@/assets/Icon/Check/Half Active.svg" alt />
                Number
              </th>
              <th class="price">State</th>
              <th class="price">Lata</th>
              <th class="price">Npa</th>
              <th class="price">MRC</th>
              <th class="price">NRC</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="line"
              v-if="dids.length > 0"
              v-for="(did, k) in dids"
              :key="k"
              :class="{'active' : did.active}"
              @click="isActive(did)"
            >
              <th class="number">
                <img v-if="did.active" class="number-icon" src="@/assets/Icon/Check/Active.svg" alt />
                <img v-else class="number-icon" src="@/assets/Icon/Check/Default.svg" alt />
                <!-- <img class="number-icon" @click="$router.push({name: 'company-admin-edit-user', params: {id: user.userId}})"
                                src="@/assets/Icon/Check/Half Active.svg"
                alt="">-->
                {{did.number}}
              </th>
              <th>{{did.state}}</th>
              <th>{{did.lata}}</th>
              <th>{{did.npa}}</th>
              <th>{{did.mrc}}</th>
              <th>{{did.nrc}}</th>
            </tr>
          </tbody>
        </table>
        </div>
        <div class="buttons-wrapper">
          <pagination-component
            @change-page="changePage($event)"
            :page="Page"
            :perPage="count"
            :total="TotalPages"
            :qnt="dids.length"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BuyDidModal from "./BuyeDidModal.vue";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Loader: () => import("@/components/Loader.vue")
  },
  data: () => ({
    contactError: null,
    role: ["Default", "Premium"],
    types: ["Virtual", "Landline", "Toll Free", "Mobile"],
    did_types: ["ANI", "DNIS"],
    counts: [
      { name: "10", value: "10" },
      { name: "20", value: "20" },
      { name: "30", value: "30" },
      { name: "50", value: "50" },
      { name: "100", value: "100" }
    ],
    SearchDid: "",
    dids: [],
    TotalPages: null,
    active: false,
    Page: 0,
    countrys: [],
    area_codes: [],
    countryId: "",
    area_code: "",
    type: "",
    did_type: "",
    dialog: null,
    selectedDid: null,
    selectedDidForBuy: [],
    states: [],
    latas: [],
    npas: [],
    npa: null,
    pattern: "**********",
    state: null,
    lata: null,
    count: "10",
    loading: true
  }),
  created() {
    this.getNpaList();
    this.getStateList();
    this.getLataList();
    this.GetList();
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    handleNpaSearch(v) {
      this.npa = v;
    },
    handleStateSearch(v) {
      this.state = v;
    },
    handleLataSearch(v) {
      this.lata = v;
    },
    handlePatternSearch(v) {
      if (v.length <= 10) {
        this.pattern = v;
      }
    },
    handleCountSearch(v) {
      this.count = v;
    },
    search() {
      this.GetList();
    },
    openDialog() {
      if (this.selectedDid) {
        this.$modal.show(
          BuyDidModal,
          { did: this.selectedDid },
          {
            draggable: true,
            width: "25%",
            height: "auto",
            scrollable: true
          },
          {
            "before-close": this.beforeClose
          }
        );
      }
    },
    beforeClose() {
      this.GetList();
    },
    getCountryList() {
      this.$store
        .dispatch("getCountryList", {
          nice_name: ""
        })
        .then(res => {
          this.countrys = res.items;
        });
    },
    isActive(did) {
      // console.log(did,'111')
      if (!did.active){
        did.active = true
        this.selectedDidForBuy = [...this.selectedDidForBuy,did]
      }else{
        let newSelected = this.selectedDidForBuy.filter((item) => item !== did && did.active)
        this.selectedDidForBuy = newSelected
        did.active = false
      }
      console.log(this.selectedDidForBuy,'2222')

      this.selectedDid = did;
      // this.active = !this.active;
      // this.dids.map(item => {
      //   if (item == did) {
      //     did.active = !did.active;
      //   } else {
      //     item.active = false;
      //   }
      // });
    },
    GetList() {
      this.loading = true;
      this.$store
        .dispatch("getAllSearchedDid", {
          npa: this.npa || "",
          pattern: this.pattern || "",
          state: this.state || "",
          lata: this.lata || "",
          count: this.count || 10
        })
        .then(res => {
          console.log(res.items, "111");
          this.dids = res.items.map(this.transformDids);
          this.TotalPages = res.total / res.per_page;
          // this.loading = false;
          if (this.dids.length === 0) {
            this.$warning("No result found");
          }
        })
        .catch(err => this.$error(err))
        .finally(() => (this.loading = false));
    },
    transformDids(i, k) {
      return {
        number: i.number,
        location: i.area ? i.area.location : "",
        price: i.fees ? i.fees.price : "",
        type: i.type,
        mrc: i.mrc,
        nrc: i.nrc,
        state: i.state,
        lata: i.lata,
        npa: i.npa,
        active: false
      };
    },
    getStateList() {
      this.$store
        .dispatch("getStateList")
        .then(res => {
          let data = [];
          data.push({ name: "All", value: "" });

          res.items.map(item => {
            if (item.state) {
              data.push({ name: item.state, value: item.state });
            }
          });
          this.states = data;
        })
        .catch(err => this.$error(err));
    },
    getLataList() {
      this.$store
        .dispatch("getLataList")
        .then(res => {
          let data = [];
          data.push({ name: "All", value: "" });
          res.items.map(item => {
            if (item.lata) {
              data.push({ name: item.lata, value: item.lata });
            }
          });
          this.latas = data;
        })
        .catch(err => this.$error(err));
    },
    getNpaList() {
      this.$store
        .dispatch("getNpaList")
        .then(res => {
          let data = [];
          data.push({ name: "All", value: "" });
          res.items.map(item => {
            if (item.npa) {
              data.push({ name: item.npa, value: item.npa });
            }
          });
          this.npas = data;
        })
        .catch(err => this.$error(err));
    },
    buyDid() {
      let dataNumber = this.selectedDidForBuy.map((item)=> ({number: item.number}))
      if (this.selectedDidForBuy) {
        this.$store
                .dispatch("buyDid", { items: dataNumber })
                .then(res => {
                  if (
                          res.data.payload.items[0] &&
                          res.data.payload.items[0].status === "error"
                  ) {
                    res.data.payload.items.map(item => {
                      this.$snotify.error(item.error);
                    });
                  } else {
                    this.selectedDidForBuy = []
                    this.$success("DID has bed bought");
                    this.$router.push({ name: "company-admin-dids" });
                  }
                })
                .catch(err => this.$error(err));
      }



      // if (this.selectedDid) {
      //   this.$store
      //     .dispatch("buyDid", { items: [{ number: this.selectedDid.number }] })
      //     .then(res => {
      //       if (
      //         res.data.payload.items[0] &&
      //         res.data.payload.items[0].status === "error"
      //       ) {
      //         res.data.payload.items.map(item => {
      //           this.$snotify.error(item.error);
      //         });
      //       } else {
      //         this.$success("DID has bed bought");
      //         this.$router.push({ name: "company-admin-dids" });
      //       }
      //     })
      //     .catch(err => this.$error(err));
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.buy-did-container {
  font-family: "Helvetica Neue";
  .add-navigation {
    padding: 0 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: fit-content;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .right-wrapprr {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: fit-content;
      width: 80%!important;
      .search-input {
        height: 36px;
        width: 280px;
        background-color: #ffffff;
        margin-top: 20px;
        margin-right: 20px;
      }
      .select {
        width: 200px;
        margin-right: 20px;
      }
      .search_button {
        margin-top: 20px;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: 20%!important;
      margin-top: 20px;
      .primary-button {
        height: 40px;
        width: 140px;
        margin-right: 15px;
      }
    }
  }
  @media only screen and (max-width: 1855px) {
    .add-navigation {
      .right-wrapprr {
        .select {
          margin-bottom: 20px;
        }
        .search-input {
          margin-bottom: 20px;
        }
        .search_button {
          margin-top: 0;
        }
      }
      .buttons-wrapper {
        margin-top: 0;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    width: 100%;
    background-color: #ffffff;
    padding: 15px 0 15px 0;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      margin-left: 20px;
    }
    .table-container {
      font-family: "Helvetica Neue";
      align-items: center;
      padding: 0;
      margin: 0;
      .buttons-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
        margin-top: 20px;
        .secondary-but.ton {
          height: 40px;
          width: 90px;
          margin-right: 15px;
        }
      }
      .navigation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        .country {
          height: 40px;
          width: 250px;
          margin-bottom: 10px;
          color: #55616e;
          font-weight: normal;
          padding-right: 15px;
          margin-left: 15px;
        }
        .did_type {
          height: 40px;
          width: 120px;
          color: #55616e;
          font-weight: normal;
          padding-right: 20px;
          margin-bottom: 10px;
        }
        .search-input {
          height: 40px;
          width: 490px;
          background-color: #ffffff;
          margin: 30px 0 0 0;
        }
        .type {
          height: 40px;
          width: 120px;
          color: #55616e;
          font-weight: normal;
          margin-bottom: 10px;
          padding-left: 20px;
          margin-right: 15px;
        }
      }
    }
  }
}

table.Invoice_table {
  width: 100%;
  margin-top: 10px;
}
table thead tr {
  background: #ffffff;
  text-align: left;
  box-shadow: inset 0 0px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 0px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 0px 0 0 #f0f1fa;
}
table thead tr {
  .number {
    padding-left: 15px;
    width: 255px;
    img {
      margin-right: 5px;
    }
  }
  .type {
    width: 117px;
  }
  .location {
    width: 510px;
  }
  .price {
  }
}

table,
tr {
  width: 100%;
  height: 37px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr.active {
  border: 1px solid #51a3f3;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
}
table tr th {
  padding: 13px 0;
}
table {
  font-family: "Helvetica Neue";
  border-collapse: collapse;
}
.Invoice_table_popup {
  float: right;
  width: 75px;
}
.Invoice_table_header th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  padding: 11px 0 10px 0;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.number-icon {
  height: 16px;
  width: 16px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  padding: 10px 15px 10px 0;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
  text-align: left;
}
tbody th.icon-right {
  display: flex;
  padding: 7px 20px 7px 0;
  height: 30px;
  width: 30px;
  color: #55616e;
}
table th:first-child {
  padding-left: 20px;
}
tbody th.number {
  padding: 14px 0 14px 15px;
  img {
    margin-right: 5px;
  }
}
tbody th.method {
  width: 110px;
  color: #55616e;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 25px;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-left: 8px;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 25px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}
.no_title{
  margin-top: 20px;
}

.row{
  align-items: center;
}
@media (max-width: 1280px) {
  table.Invoice_table {
    width: 1170px;
  }
}
@media (max-width: 767px) {
  .search_margin{
    margin-bottom: 20px;
  }
}
</style>

